import { Table } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { RootState } from '../../../store';
import { applyFilters, fetchConsentList, resetFilter } from '../../../store/actions/abdmHiuAction';
import { ABDMHiuState } from '../../../store/models/abdmHIUModel';
import { base64UrlEncode } from '../../../utils/utility';
import { checkEmptyObj } from '../../crm/inPatient/service/crmUtils';
import { CONSENT_LIST_COLS } from '../abdmConstants';

const List = (): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pageNoParam = searchParams.get('pageNo');
  const [data, setData] = useState<any[]>([]);
  const [pageNo, setPageNo] = useState<any>(1);
  const [finalData, setFinalData] = useState<any[]>([]);
  const [tblLoading, setTblLoading] = useState(false);
  const { reloadList, filters, searchClicked} = useSelector((state: RootState): ABDMHiuState => state.abdmHiu);

  const rowClick = (ev: any, record: any, rowIndex: any): any => {
    const encodedRecord = base64UrlEncode(JSON.stringify(record));
    history.push(`/abdm/concent-detail/${encodedRecord}`);
    dispatch(applyFilters({abhaAddress: ''}));
  };

  useEffect((): any => {
    if (!pageNoParam) {
      const paramsToAdd = new URLSearchParams(history.location.search);
      paramsToAdd?.set('pageNo', '1');
      history.push({ search: paramsToAdd.toString() });
    }
    dispatch(resetFilter({}));
  }, []);

  useEffect((): any => {
    setTblLoading(true);
    dispatch(fetchConsentList(setConsentList));
  }, [reloadList]);

  useEffect((): void => {
    setPageNo(pageNoParam ? parseInt(pageNoParam, 10) : pageNo);
  }, [pageNoParam]);

  useEffect((): void => {
    dispatch(fetchConsentList(setConsentList));
  }, [searchClicked]);

  const setConsentList = (list: any[] = []): any => {
    setData(list);
    setTblLoading(false);
  };

  // ! Applying filters
  useEffect((): any => {
    if (!checkEmptyObj(filters)) {
      const tempData = data?.filter((ele: any): boolean => {
        if (
          String(ele['abhaAddress']).toLowerCase().includes((filters.abhaAddress || '')?.toLowerCase())
        ) {
          return true;
        } else {
          return false;
        }
      });
      tempData?.sort((a: any, b: any): any => new Date(b.requestTime).getTime() - new Date(a.requestTime).getTime());
      setFinalData(tempData);
    } else {
      data?.sort((a: any, b: any): any => new Date(b.requestTime).getTime() - new Date(a.requestTime).getTime());
      setFinalData(data);
    }
  }, [filters, data]);

  const pageChange = (pageNumber: any): void => {
    const searchParamsToChange = new URLSearchParams(history.location.search);
    searchParamsToChange?.set('pageNo', pageNumber);
    history.push({ search: searchParamsToChange.toString() });
    setPageNo(pageNumber);
  };

  return (
    <Table
      onRow={(record: any, rowIndex: any): any => {
        return {
          onClick: (event: any): any => { rowClick(event, record, rowIndex); },
        };
      }}
      loading={tblLoading}
      columns={CONSENT_LIST_COLS}
      dataSource={finalData}
      className="tableClass"
      rowKey="id"
      pagination={{ pageSize: 10, position: ['bottomCenter'], onChange: pageChange, current: pageNo }}
      />
  );
};

export default List;
